import { __decorate, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { Inline } from '../pvd-utils/enums/inline.js';
import { TextAlign } from '../pvd-utils/enums/text-align.js';

const DEFAULT_ALIGN = TextAlign.center;
const DEFAULT_BODY_FULL_WIDTH = false;
const DEFAULT_DENSE = false;
const DEFAULT_HEADING_FULL_WIDTH = false;
const DEFAULT_INLINE = Inline.never;
const DEFAULT_INLINE_IMAGE_POSITION_RIGHT = false;
const DEFAULT_TILE = false;
/**
 * Providence Content Block component.
 * @see {@link https://providence.fmr.com/4.x/components/content-block/content-block.html|Content Block documentation}
 */
class PvdContentBlock extends PvdSlotifyBaseComponent {
    constructor() {
        super(...arguments);
        //#endregion
        // #region LitElement properties
        this.pvdAlign = DEFAULT_ALIGN;
        this.pvdBodyFullWidth = DEFAULT_BODY_FULL_WIDTH;
        this.pvdDense = DEFAULT_DENSE;
        this.pvdHeadingFullWidth = DEFAULT_HEADING_FULL_WIDTH;
        this.pvdInline = DEFAULT_INLINE;
        this.pvdInlineImagePositionRight = DEFAULT_INLINE_IMAGE_POSITION_RIGHT;
        this.pvdTileBackground = DEFAULT_TILE;
        //#endregion
    }
    // #endregion
    // #region protected methods
    get hasImage() {
        return this.isSlotUsed('image');
    }
    get hasHeading() {
        return this.isSlotUsed('heading');
    }
    get hasBody() {
        return this.isSlotUsed();
    }
    get hasAction() {
        return this.isSlotUsed('action');
    }
    // #endregion
    // #region LitElement lifecycles
    render() {
        const classMap = {
            default: `${this.constructor.namespace}-content-block-root`,
            modifierPrefix: 'pvd-content-block',
            modifiers: [
                {
                    condition: this.pvdAlign !== DEFAULT_ALIGN,
                    className: `align-${this.pvdAlign}`,
                },
                {
                    condition: this.pvdActionAlign !== undefined,
                    className: `action-align-${this.pvdActionAlign}`,
                },
                {
                    condition: this.pvdBodyAlign !== undefined,
                    className: `body-align-${this.pvdBodyAlign}`,
                },
                {
                    condition: this.pvdBodyFullWidth,
                    className: 'body-full-width',
                },
                {
                    condition: this.pvdDense,
                    className: 'dense',
                },
                {
                    condition: this.pvdHeadingAlign !== undefined,
                    className: `heading-align-${this.pvdHeadingAlign}`,
                },
                {
                    condition: this.pvdHeadingFullWidth,
                    className: 'heading-full-width',
                },
                {
                    condition: this.pvdImageAlign !== undefined,
                    className: `image-align-${this.pvdImageAlign}`,
                },
                {
                    condition: this.pvdInline !== undefined,
                    className: `inline-${this.pvdInline}`,
                },
                {
                    condition: this.pvdInlineImagePositionRight,
                    className: 'inline-image-position-right',
                },
                {
                    condition: this.pvdTileBackground,
                    className: 'tile-background',
                },
            ],
        };
        return x `<div class="${getClassName(classMap)}">${this.hasImage
            ? x `<div class="pvd-content-block__image-wrapper"><s-slot name="image"></s-slot></div>`
            : x `<s-slot name="image"></s-slot>`}<div class="pvd-content-block__content-wrapper">${this.hasHeading
            ? x `<div class="pvd-content-block__heading-wrapper"><div class="pvd-content-block__heading-content"><s-slot name="heading"></s-slot></div></div>`
            : x `<s-slot name="heading"></s-slot>`} ${this.hasBody
            ? x `<div class="pvd-content-block__body-wrapper"><div class="pvd-content-block__body-content"><s-slot></s-slot></div></div>`
            : x `<s-slot></s-slot>`} ${this.hasAction
            ? x `<div class="pvd-content-block__action-wrapper"><s-slot name="action"></s-slot></div>`
            : x `<s-slot name="action"></s-slot>`}</div></div>`;
    }
}
//#region Component configuration
PvdContentBlock.componentName = 'content-block';
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-align',
        ...PvdSlotifyBaseComponent.hasChanged(TextAlign),
    }),
    __metadata("design:type", String)
], PvdContentBlock.prototype, "pvdAlign", void 0);
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-action-align',
        ...PvdSlotifyBaseComponent.hasChanged(TextAlign),
    }),
    __metadata("design:type", String)
], PvdContentBlock.prototype, "pvdActionAlign", void 0);
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-body-align',
        ...PvdSlotifyBaseComponent.hasChanged(TextAlign),
    }),
    __metadata("design:type", String)
], PvdContentBlock.prototype, "pvdBodyAlign", void 0);
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-body-full-width',
        ...PvdSlotifyBaseComponent.booleanAttribute('pvd-body-full-width'),
    }),
    __metadata("design:type", Boolean)
], PvdContentBlock.prototype, "pvdBodyFullWidth", void 0);
__decorate([
    n({
        type: Boolean,
        reflect: true,
        attribute: 'pvd-dense',
        ...PvdSlotifyBaseComponent.booleanAttribute('pvd-dense'),
    }),
    __metadata("design:type", Boolean)
], PvdContentBlock.prototype, "pvdDense", void 0);
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-heading-align',
        ...PvdSlotifyBaseComponent.hasChanged(TextAlign),
    }),
    __metadata("design:type", String)
], PvdContentBlock.prototype, "pvdHeadingAlign", void 0);
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-heading-full-width',
        ...PvdSlotifyBaseComponent.booleanAttribute('pvd-heading-full-width'),
    }),
    __metadata("design:type", Boolean)
], PvdContentBlock.prototype, "pvdHeadingFullWidth", void 0);
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-image-align',
        ...PvdSlotifyBaseComponent.hasChanged(TextAlign),
    }),
    __metadata("design:type", String)
], PvdContentBlock.prototype, "pvdImageAlign", void 0);
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-inline',
        ...PvdSlotifyBaseComponent.hasChanged(Inline),
    }),
    __metadata("design:type", String)
], PvdContentBlock.prototype, "pvdInline", void 0);
__decorate([
    n({
        type: Boolean,
        reflect: true,
        attribute: 'pvd-inline-image-position-right',
        ...PvdSlotifyBaseComponent.booleanAttribute('pvd-inline-image-position-right'),
    }),
    __metadata("design:type", Boolean)
], PvdContentBlock.prototype, "pvdInlineImagePositionRight", void 0);
__decorate([
    n({
        type: Boolean,
        reflect: true,
        attribute: 'pvd-tile-background',
        ...PvdSlotifyBaseComponent.booleanAttribute('pvd-tile-background'),
    }),
    __metadata("design:type", Boolean)
], PvdContentBlock.prototype, "pvdTileBackground", void 0);

export { DEFAULT_ALIGN, DEFAULT_BODY_FULL_WIDTH, DEFAULT_DENSE, DEFAULT_HEADING_FULL_WIDTH, DEFAULT_INLINE, DEFAULT_INLINE_IMAGE_POSITION_RIGHT, DEFAULT_TILE, PvdContentBlock };
//# sourceMappingURL=pvd-content-block.js.map
